import { useSelector } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { vocabularyCodes } from '@/vocabularies/constants';

const useAbout = () => {
  const { about: allowAbout } = useSelector(({ app }) => app);
  return { allowAbout };
};

const useAboutDialog = () => useSelector(({
  app: { version },
  auth: { idToken },
  vocabularies: { vocabularies },
}) => {
  const vocabulary = findResult(vocabularies, 'all', vocabularyCodes.DRE_NAME);

  return {
    authToken: idToken ? idToken.idToken.rawIdToken : '',
    dreName: vocabulary ? (vocabulary.value || vocabulary.original) : '',
    version,
  };
});

export default {
  useAbout,
  useAboutDialog,
};
